<template>
  <div>
    <h3>Gegevens</h3>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Naam</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input
            name="name"
            type="text"
            v-model="nameValue"
            v-decorator="[
              'name',
              { rules: [{ required: true, message: 'Voer aub een naam in' }] }
            ]"
            placeholder="Regio naam"
            :class="errors.length && !nameValue ? 'has-error' : ''"
        />
        <span v-if="errors.length > 0" v-for="error in errors" class="errors">
          {{ error }}
        </span>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Code</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input
            name="code"
            type="text"
            v-model="codeValue"
            placeholder="Regio code"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Hoofdregio</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-select
            v-if="regions.length"
            v-model="parentValue"
            :allowClear="allowClear"
            :filter-option="filterOption"
            :show-search="showSearch"
            option-filter-prop="children"
            placeholder="Selecteer een regio"
            @change="handleChange">
          <a-select-option
              v-for="region in regionsWithoutSelf"
              :key="region.id"
              :value="region.id">
            {{ region.name }}
          </a-select-option>
        </a-select>

        <a-alert v-else message="Geen hoofdregio's gevonden." type="info" :show-icon="true"/>
        <input type="text" hidden name="parent_id" :value="parentValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Gebruikers</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <users-select
            :value="usersWorkAt"
            fieldName="users_work_at[]"
            @change="setWorksAtSelection"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Kantoren</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <select-office-component
            :selected-office-ids="officesValue"
            fieldName="office_ids[]"
            @office-selection="setOfficeSelection"/>
      </div>
    </div>

    <input v-if="regionId" type="text" hidden name="region_id" :value="regionId"/>
  </div>
</template>


<script>
import selectOfficeComponent from '../../office/components/SelectOfficeComponent';

export default {
  name: "RegionComponent",
  props: {
    name: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    regions: {
      type: Array,
      default: () => ([])
    },
    regionId: {
      type: [Number, String],
      default: null
    },
    parentId: {
      type: Number,
      default: null
    },
    usersWorkAt: {
      type: Array,
      default: () => ([])
    },
    offices: {
      type: Array,
      default: () => ([])
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    errors: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    selectOfficeComponent,
  },
  created() {
  },
  data() {
    return {
      nameValue: this.name,
      codeValue: this.code,
      parentValue: this.parentId,
      usersWorkAtValue: this.usersWorkAt,
      officesValue: this.offices,
      loading: false,
      showSearch: true, // region select
      allowClear: true // region select
    }
  },
  methods: {
    handleChange(value) {
      this.parentValue = value;
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    setOfficeSelection(value) {
      this.officesValue = value;
    },
    setWorksAtSelection(value) {
      this.usersWorkAtValue = value;
    },
  },
  computed: {
    regionsWithoutSelf() {
      return this.regions.filter(region => region.id !== this.regionId);
    }
  }
}
</script>

<style scoped>
.errors {
  color: #f5222d;
  font-style: italic;
}

.has-error {
  border-color: #f5222d;
}
</style>
